export default {
// 机台状态切换配置 el-button
tabInfo: [
  { name: '全部', type: 'primary' },
  { name: '正常', type: 'success' },
  { name: '停机', type: 'warning' },
  { name: '异常', type: 'danger' },
  { name: '离线', type: 'info' }
],
tabNames: ['全部', '正常', '停机', '异常', '离线'],
tabType: ['primary', 'success', 'warning', 'danger', 'info'],
// 若找不到机台机台状态，则算停机（橙色）
tabDefault: 2,
// 全部的下标
allIndex: 0
}
